import React, { useState, useEffect, useRef } from 'react';
import { fetchAddressData,fetchMemberData,submitAddressData,confirmAddressData} from '../../services/api'; 
import { sendSACCode, verifySACCode } from '../../services/secure_accesscode';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import './AddressChange.css';
import '../../styles/output.css';
import '../../styles/index.css';

import menuItems from '../SideMenu/menuItems';
import { SideMenu, Header, TopMenu } from 'maxcu-shared-lib';

function AddressChange() {
    function usePersistentState(key, initialValue) {
    const [value, setValue] = useState(() => {
        const stored = sessionStorage.getItem(key);
        return stored !== null ? JSON.parse(stored) : initialValue;
    });
    useEffect(() => {
        sessionStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);
    return [value, setValue];
}

    const [addressData, setAddressData] = useState(null);
    const [addressConfirmData, setAddressConfirmData] = useState(null);
    const [addressSubmitData, setAddressSubmitData] = useState(null);
    
    const [error, setError] = useState(null);
    
    const [message, setMessage] = useState({type: '',text: ''});
    const [loading,setLoading] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState(false);
   
    const [street, setStreet] = usePersistentState('addressChange_street', '');
    const [city, setCity] = usePersistentState('addressChange_city', '');
    const [state, setState] = usePersistentState('addressChange_state', '');
    const [zipcode, setZipcode] = usePersistentState('addressChange_zipcode', '');
    const [homePhone, setHomePhone] = usePersistentState('addressChange_homePhone', '');
    const [workPhone, setWorkPhone] = usePersistentState('addressChange_workPhone', '');
    const [workExt, setWorkExt] = usePersistentState('addressChange_workExt', '');
    const [mobilePhone, setMobilePhone] = usePersistentState('addressChange_mobilePhone', '');
    const [email, setEmail] = usePersistentState('addressChange_email', '');

    const [contactMethod,setContactMethod] = usePersistentState('addressChange_cmethod', '');
    const [checkBox,setCheckBox] = usePersistentState('addressChange_cbox', false);
    const [promotional,setPromotional] = usePersistentState('addressChange_promo', '');
    const [selectedAddress, setSelectedAddress] = useState('current');
    const refStreet = useRef('');
    const [confirmModal, setIsConfirmModalOpen] = useState(false);
    const [modalStep, setModalStep] = useState('confirm'); // 'confirm', 'mfa-method', 'mfa-code'
    const [selectedMfaMethod, setSelectedMfaMethod] = useState('');
    const [mfaCode, setMfaCode] = useState('');
    const [mfaError, setMfaError] = useState('');
    const [memberInfo, setMemberInfo] = useState(null);
    const [selectedPhoneIndex, setSelectedPhoneIndex] = useState(null);
    const [isCollapsed, setIsCollapsed] = useState(false);
    
    const [mfaMethod, setMfaMethod] = useState(''); // New state for MFA method 
    const redirect = process.env.REACT_APP_PLUGIN_REDIRECTURI;

    useEffect(() => {
        let isMounted = true;
        document.title = "Update Contact Info | MAX Credit Union";
        const getData = async () => {
            try {
                const result = await fetchAddressData();
                if (isMounted) {
                    setAddressData(result);
                    assignVariable(result);
                    refStreet.current=street;
                }
                const member_info = await fetchMemberData();
                if (isMounted) {
                    setMemberInfo(member_info);
                }
            } catch (err) {
                if (isMounted) {
                    setError(err);
                }
            }
        };

        getData();
        
        const handleResize = () => {
            if (window.innerWidth < 600) {
                setIsCollapsed(true);
            } else {
                setIsCollapsed(false);
            }
        };

        handleResize(); // Set initial state

        window.addEventListener('resize', handleResize);
        
        return () => {
            isMounted = false;
        };
    }, []);
    
// Add phone formatting helper
function formatPhoneNumber(value) {
    // Remove all non-digit characters
    const cleaned = ('' + value).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (!match) return '';
    let formatted = '';
    if (match[1]) {
        formatted = match[1];
    }
    if (match[2]) {
        formatted += (match[2] ? '-' + match[2] : '');
    }
    if (match[3]) {
        formatted += (match[3] ? '-' + match[3] : '');
    }
    return formatted;
}
    const getMemberData = async () => {
        const member_info = await fetchMemberData();
        if (member_info) {
            setMemberInfo(member_info);
        }
        else {
            console.error('No member data found');
        }
    };

    const handleVerifySACCode = async () => {
        if (selectedPhoneIndex !== null && mfaCode.length === 6) {
            const [label, phone] = phoneEntries[selectedPhoneIndex];
            const cleanPhone = phone.replace(/\D/g, '');
            try {
                const result = await verifySACCode(cleanPhone, mfaCode);
                if (result.status === 'approved') { // Use strict comparison
                    handleSubmitAddressChange();
                    setModalStep('confirm');
                    setMfaCode('');
                } else {
                    setMfaError('Invalid code. Please try again.');
                }
            } catch (err) {
                setMfaError('Verification failed. Please try again.');
            }
        } else {
            setMfaError('Please enter a 6-digit code.');
        }
    };

    const setNewAddress = () => {
        if (addressConfirmData.secondaryAddress === null || addressConfirmData.secondaryAddress === 'UNDEFINED') {
          setStreet(addressConfirmData.streetAddress);
        } else {
          setStreet(addressConfirmData.streetAddress+" "+addressConfirmData.secondaryAddress);
        }
        setCity(addressConfirmData.city);   
        setState(addressConfirmData.state);
        setZipcode(addressConfirmData.ZIPCode+"-"+addressConfirmData.ZIPPlus4);
    }

    const handleConfirmAddressChange = async () => {
        setLoading(true);
        setMessage({ type: '', text: '' });
        if (checkBox){setPromotional('Yes')} else {setPromotional('No')}
        try {
            const response = await confirmAddressData({
                streetAddress: street, 
                city: city, 
                state: state, 
                zipCode: zipcode
            });
            if (response === "invalid") {
                setLoading(false); 
                setMessage({
                    type: 'invalid',
                    text: 'The address you entered is not valid. Please check and try again.'
                });
                return;
            }
            setAddressConfirmData(response);
            
        console.log(response);
            // Check response for success/failure
            if (response) { // Adjust this condition based on your API response
                setLoading(false);  
                setMessage({
                    type: 'successConfirm',
                    text: 'Your address '+response.selected+' has successfully changed!'
                });
                setIsSubmitted(true);
            } else {
                setLoading(false); 
                setMessage({
                    type: 'error',
                    text: response || 'Address Change could not be processed. Please try again.'
                });
            }
        } catch (error) {
            console.error('Error confirming address change:', error);
            setLoading(false); 
            setMessage({
                type: 'error',
                text: 'An error occurred while processing your request. Please try again.'
            });
        }
    }
    function maskPhoneNumber(phone) {
      // phone should be a string of digits
      const digits = phone.replace(/\D/g, '');
      return `(***) ***-${digits.slice(-4)}`;
    }

    const getFilteredPhones = (phoneObj) => {
      if (!phoneObj) return [];
      const cellRaw = phoneObj.cell || '';
      const homeRaw = phoneObj.home || '';
      const cell = cellRaw.replace(/\D/g, '');
      const home = homeRaw.replace(/\D/g, '');

      // If both are empty, return empty array
      if (!cell && !home) return [];

      // If both exist and are the same, show only cell
      if (cell && home && cell === home) {
        return [['cell', cellRaw]];
      }

      // Otherwise, show both if they exist
      const result = [];
      if (cell) result.push(['cell', cellRaw]);
      if (home) result.push(['home', homeRaw]);
      return result;
    };

    const phoneEntries = memberInfo && memberInfo.phone_number
      ? getFilteredPhones(memberInfo.phone_number)
      : [];

    const handleSendSACCode = async (method) => {
        if (selectedPhoneIndex !== null && method) {
            const [label, phone] = phoneEntries[selectedPhoneIndex];
            const cleanPhone = phone.replace(/\D/g, ''); // Remove all non-digit characters
            try {
                await sendSACCode(cleanPhone, method);
                setModalStep('mfa-code');
            } catch (err) {
                setMfaError('Failed to send code. Please try again.');
            }
        }
    };
    const assignVariable = (addressData) => {
            if (street === '' || street === null) {
            setStreet(addressData.street);
            setCity(addressData.city);   
            setState(addressData.state);
            setZipcode(addressData.zipcode);
            setHomePhone(addressData.home);
            setWorkPhone(addressData.workph);
            setWorkExt(addressData.workext);
            setMobilePhone(addressData.mobile);
            setEmail(addressData.email);
            if (addressData.cmethod !== '' && addressData.cmethod !== null) {
                setContactMethod(addressData.cmethod);
            } else {
                setContactMethod('CALL HOME');
            }
            if (addressData.tcpa === '0') {
                setCheckBox(true);
            } else {
                setCheckBox(false);
            }}
    }

    const handleSubmitAddressChange = async () => {
        setLoading(true);
        setMessage({ type: '', text: '' });
        let theAddress;
        try {
            let tc;
            if (checkBox) {
                tc=0;
            } else {
                tc=1
            }
            
            if (addressConfirmData.secondaryAddress === null || addressConfirmData.secondaryAddress === 'UNDEFINED') {
                theAddress = addressConfirmData.streetAddress+","+addressConfirmData.city+","+addressConfirmData.state+","+addressConfirmData.ZIPCode+"-"+addressConfirmData.ZIPPlus4;
            } else {
                theAddress = addressConfirmData.streetAddress+" "+addressConfirmData.secondaryAddress+","+addressConfirmData.city+","+addressConfirmData.state+","+addressConfirmData.ZIPCode+"-"+addressConfirmData.ZIPPlus4;
            }
            const response = await submitAddressData({
                address: theAddress,
                phone: homePhone+","+workPhone+","+workExt+","+mobilePhone,
                emailSlashPromo: email,
                tcpa: tc+","+contactMethod
            });
            setAddressSubmitData(response);
            
            // Check response for success/failure
            if (response) { // Adjust this condition based on your API response
                setLoading(false);  
                setMessage({
                    type: 'successSubmit',
                    text: 'Your address '+response.selected+' has been changed!'
                });
                setIsSubmitted(true);
            } else {
                setLoading(false); 
                setMessage({
                    type: 'error',
                    text: response || 'Address Change could not be processed. Please try again.'
                });
            }
            
        } catch (error) {
            console.error('Error submitting Address Change:', error);
            setLoading(false); 
            setMessage({
                type: 'error',
                text: 'An error occurred while processing your request. Please try again.'
            });
        }
    };   
    
    if (error) return <div>Error: {error.message}</div>;
    if (!addressData) return <div className="throbber items-center justify-center"></div>;

    return (
    <div className="min-h-screen flex flex-col">
        <SideMenu menuItems={menuItems} />
          <div style={{ flex: 1 }} className={`${isCollapsed ? 'sb-thin' : 'sb-wide'}`}>
          <Header name="Update Contact Info" />
          {isCollapsed && <TopMenu />}
          {message.text === '' && (
             <div style={{marginLeft: '20%', marginRight: '20%'}}><p>Don't miss important account communications. 
                Review your information and update your address with MAX if needed. 
                Please Note: This will update the primary account holder's address and contact information only. 
                Joint account holders who need to update their contact information can visit a branch or contact us at 334.260.2600 or 800.776.6776.</p></div>
          )}
          <br/>
        {
        loading ? (
            <div>
                <div className="throbber items-center justify-center"></div>
            </div>
        ) 
        : message.text && message.type !== "invalid" ? (
            <div className="flex-grow flex flex-col items-center justify-center space-y-8">
                {
                    message.type==='successConfirm' ? (
                        <div className="flex-grow flex flex-col items-center justify-center space-y-8">
                            <p style={{marginRight: '5%', marginLeft: '5%'}}>Please review the address below and confirm this is correct.</p>
                            <br/>
                            <div className="flex justify-between space-x-8">
                                <div className="flex flex-col text-gray-700 text-base space-y-2">
                                    <strong>
                                        {(addressConfirmData.secondaryAddress === null || addressConfirmData.secondaryAddress === 'UNDEFINED') ? (
                                            <p>{addressConfirmData.streetAddress}</p> 
                                        ) : (   
                                            <p>{addressConfirmData.streetAddress+" "+addressConfirmData.secondaryAddress}</p> 
                                        )}
                                        <p>{addressConfirmData.city}, {addressConfirmData.state},</p>
                                        <p>{addressConfirmData.ZIPCode+"-"+addressConfirmData.ZIPPlus4}</p>
                                        <br/>
                                        <p>Home Phone: {homePhone}</p>
                                        <br/>
                                        <p>Work Phone: {workPhone}</p>
                                        <br/>
                                        <p>Mobile Phone: {mobilePhone}</p>
                                        <br/>
                                        <p>Email: {email}</p>
                                        <br/>
                                        <p>Preferred Contact: {contactMethod}</p>
                                        <br/>
                                        <p>Promotional Messages: {promotional}</p>
                                    </strong>
                                </div>
                            </div>
                            <br/>
                            <div>
                                <button type="button" className="mt-4 bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400 transition duration-200" onClick={() => { window.location.href = redirect;  setNewAddress();}}>Back</button>
                                <button type="submit" 
                                onClick={() => {setIsConfirmModalOpen(true); }}
                                className="mt-4 bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition duration-200">Submit</button>
                            </div>
                        {isCollapsed === false ? (
                            <Popup open={confirmModal} onClose={() => { setIsConfirmModalOpen(false); setModalStep('confirm'); }} modal nested>
                                {onClose => (
                                    <div className='modal'>
                                        {/* Common close button */}
                                        <div className="flex justify-between items-start p-2">
                                            <button 
                                                onClick={() => { onClose(); setModalStep('confirm'); getMemberData();}} 
                                                className="text-gray-600 hover:text-gray-800 text-2xl"
                                                style={{ marginLeft: 'auto', marginTop: 'auto' }}
                                                aria-label="Close"
                                            >
                                                &times;
                                            </button>
                                        </div>
                                        {/* Step 1: Confirm */}
                                        {modalStep === 'confirm' && (
                                            <>
                                        <div className='flex flex-col items-center mb-4'>
                                            <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-full mb-2">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="text-blue-600 w-6 h-6"
                                                    fill="currentColor"
                                                    viewBox="1.5 .4 24 26"
                                                >
                                                    <path d="M13.499 2.267c6.075 0 11 4.925 11 11 0 6.076-4.925 11-11 11s-11-4.924-11-11c0-6.075 4.925-11 11-11Zm0 2.2a8.8 8.8 0 1 0 0 17.6 8.8 8.8 0 0 0 0-17.6Zm1.1 6.6v7.7h-2.2v-7.7h2.2Zm-1.1-4.125a1.375 1.375 0 1 1 0 2.75 1.375 1.375 0 0 1 0-2.75Z" />
                                                </svg>
                                            </div>
                                            <h2 className='text-2xl font-semibold'>Confirm Change</h2>
                                        </div>
                                        <p className='text-center mb-4 text-lg text-gray-700'>You are about to change your contact info. Do you wish to continue?</p>
                                        <div className='actions justify-center flex mt-6'>
                                                    <button onClick={() => { setIsConfirmModalOpen(false); setModalStep('confirm'); getMemberData();}} className="bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400 transition duration-200" style={{ marginRight: 8 }}>
                                                No
                                            </button>
                                                    <button type='button' onClick={() => setModalStep('mfa-method')} className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition duration-200">
                                                Yes
                                            </button>
                                        </div>
                                            </>
                                        )}
                                        {/* Step 2: MFA Method Selection */}
                                        {modalStep === 'mfa-method' && (
                                            <>
                                                <div className='flex flex-col items-center mb-4'>
                                                    <h2 className='text-2xl font-semibold'>Verify Your Identity</h2>
                                                </div>
                                                <div style={{ textAlign: 'center', marginLeft: 40, marginRight: 40 }}>
                                                    To protect your information, we’ll send a one-time secure access code.<br/><br/>
                                                    Select a phone number:
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 16 }}>
                                                    {phoneEntries.map(([label, phone], idx) => (
                                                        <div key={idx} style={{ marginBottom: 8 }}>
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    background: '#e5e7eb',
                                                                    border: 'none',
                                                                    borderRadius: '6px',
                                                                    padding: '8px 16px',
                                                                    fontSize: '1.1rem',
                                                                    color: '#111827',
                                                                    textDecoration: 'none',
                                                                    cursor: 'pointer',
                                                                    marginBottom: '4px',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center',
                                                                    minWidth: 200,
                                                                    width: '100%',
                                                                    maxWidth: 320,
                                                                }}
                                                                onClick={() => {
                                                                    setSelectedPhoneIndex(selectedPhoneIndex === idx ? null : idx);
                                                                    setSelectedMfaMethod('');
                                                                }}
                                                            >
                                                                {maskPhoneNumber(phone.replace(/\D/g, ''))}
                                                                {/* Optionally show label: {label} */}
                                                                {selectedPhoneIndex === idx && (
                                                                <div style={{ marginTop: 8, marginLeft: 0, display: 'flex', gap: '12px' }}>
                                                                    <button
                                                                        type="button"
                                                                        onClick={(e) => {
                                                                            handleSendSACCode('sms');
                                                                            setMfaMethod('sms');
                                                                            e.stopPropagation();
                                                                        }}
                                                                        style={{
                                                                            padding: '8px 16px',
                                                                            backgroundColor: selectedMfaMethod === 'sms' ? '#0078D4' : '#f3f2f1',
                                                                            color: selectedMfaMethod === 'sms' ? '#ffffff' : '#000000',
                                                                            border: '1px solid #ccc',
                                                                            borderRadius: '4px',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                        >
                                                                        SMS Text
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        onClick={(e) => {
                                                                            handleSendSACCode('call');
                                                                            setMfaMethod('call');
                                                                            e.stopPropagation();
                                                                        }}
                                                                        style={{
                                                                            padding: '8px 16px',
                                                                            backgroundColor: selectedMfaMethod === 'call' ? '#0078D4' : '#f3f2f1',
                                                                            color: selectedMfaMethod === 'call' ? '#ffffff' : '#000000',
                                                                            border: '1px solid #ccc',
                                                                            borderRadius: '4px',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                        >
                                                                        Phone/Voice
                                                                    </button>
                                                                </div>
                                                                )}
                                                            </button>
                                                        </div>

                                                    ))}
                                                </div>
                                                <div style={{ textAlign: 'center', margin: '24px 40px 0 40px', color: '#b91c1c', fontWeight: 500, fontSize: '1rem' }}>
                                                    Security Reminder:<br />
                                                    Do not share this code with anyone. We will never ask you to provide your secure access code by phone, email, or text.
                                                </div>
                                                <div className='actions justify-center flex mt-6'>
                                                    <button onClick={() => { setIsConfirmModalOpen(false); setModalStep('confirm'); }} className="bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400 transition duration-200" style={{ marginRight: 8 }}>
                                                        Cancel
                                                    </button>
                                                    
                                                </div>
                                            </>
                                        )}
                                        {/* Step 3: MFA Code Entry */}
                                        {modalStep === 'mfa-code' && (
                                            <>
                                                <div className='flex flex-col items-center mb-4'>
                                                    <h2 className='text-2xl font-semibold'>Verify Your Identity</h2>
                                                </div>
                                                <div style={{ textAlign: 'center', margin: '0 40px 16px 40px' }}>
                                                    Please enter the 6-digit code you received to continue.
                                                </div>
                                                <div className="flex flex-col items-center space-y-4">
                                                    <input
                                                        type="text"
                                                        value={mfaCode}
                                                        onChange={e => {
                                                            // Only allow 6 digits
                                                            const val = e.target.value.replace(/\D/g, '').slice(0, 6);
                                                            setMfaCode(val);
                                                            setMfaError('');
                                                        }}
                                                        maxLength={6}
                                                        className="px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-32 text-lg text-center"
                                                        placeholder="6-digit code"
                                                    />
                                                    {mfaError && <div className="text-red-600">{mfaError}</div>}
                                                </div>
                                                <div style={{ textAlign: 'center', margin: '24px 40px 0 40px', color: '#b91c1c', fontWeight: 500, fontSize: '1rem' }}>
                                                    Security Reminder:<br />
                                                    Do not share this code with anyone. We will never ask you to provide your secure access code by phone, email, or text.
                                                </div>
                                                <div className='actions justify-center flex mt-6'>
                                                    <button onClick={() => { setIsConfirmModalOpen(false); setModalStep('confirm'); setMfaCode(''); }} className="bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400 transition duration-200" style={{ marginRight: 8 }}>
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type='button'
                                                        disabled={mfaCode.length !== 6}
                                                        onClick={handleVerifySACCode}
                                                        className={`px-6 py-2 rounded-md transition duration-200 ${mfaCode.length === 6 ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}`}
                                                    >
                                                        Verify
                                                    </button>
                                                </div>
                                                <div style={{ textAlign: 'center', marginTop: 12, marginBottom: 12 }}>
                                                    Didn’t get the code? <span style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => {handleSendSACCode(mfaMethod)}}>Resend Code</span><br/>
                                                    Need help? Contact us at <a href="tel:3342602600" style={{ color: 'blue', textDecoration: 'underline' }}>334.260.2600</a> or <a href="tel:18007766776" style={{ color: 'blue', textDecoration: 'underline' }}>1.800.776.6776</a>
                                                </div>
                                            </>
                                        )}
                                        <br/>
                                    </div>
                                )}
                            </Popup>
                        ) : (
                            <Popup open={confirmModal} onClose={() => { setIsConfirmModalOpen(false); setModalStep('confirm'); }} modal nested>
                            {onClose => (
                                <div className='modal'>
                                    {/* Common close button */}
                                    <div className="flex justify-between items-start p-2">
                                        <button 
                                            onClick={() => { onClose(); setModalStep('confirm'); getMemberData();}} 
                                            className="text-gray-600 hover:text-gray-800 text-2xl"
                                            style={{ marginLeft: 'auto', marginTop: 'auto' }}
                                            aria-label="Close"
                                        >
                                            &times;
                                        </button>
                                    </div>
                                    {/* Step 1: Confirm */}
                                    {modalStep === 'confirm' && (
                                        <>
                                    <div className='flex flex-col items-center mb-4'>
                                        <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-full mb-2">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="text-blue-600 w-6 h-6"
                                                fill="currentColor"
                                                viewBox="1.5 .4 24 26"
                                            >
                                                <path d="M13.499 2.267c6.075 0 11 4.925 11 11 0 6.076-4.925 11-11 11s-11-4.924-11-11c0-6.075 4.925-11 11-11Zm0 2.2a8.8 8.8 0 1 0 0 17.6 8.8 8.8 0 0 0 0-17.6Zm1.1 6.6v7.7h-2.2v-7.7h2.2Zm-1.1-4.125a1.375 1.375 0 1 1 0 2.75 1.375 1.375 0 0 1 0-2.75Z" />
                                            </svg>
                                        </div>
                                        <h2 className='text-2xl font-semibold'>Confirm Change</h2>
                                    </div>
                                    <p className='text-center mb-4 text-lg text-gray-700'>You are about to change your contact info. Do you wish to continue?</p>
                                    <div className='actions justify-center flex mt-6'>
                                                <button onClick={() => { setIsConfirmModalOpen(false); setModalStep('confirm'); getMemberData();}} className="bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400 transition duration-200" style={{ marginRight: 8 }}>
                                            No
                                        </button>
                                                <button type='button' onClick={() => setModalStep('mfa-method')} className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition duration-200">
                                            Yes
                                        </button>
                                    </div>
                                        </>
                                    )}
                                    {/* Step 2: MFA Method Selection */}
                                    {modalStep === 'mfa-method' && (
                                        <>
                                            <div className='flex flex-col items-center mb-4'>
                                                <h2 className='text-2xl font-semibold'>Verify Your Identity</h2>
                                            </div>
                                            <div style={{ textAlign: 'center', marginLeft: 40, marginRight: 40 }}>
                                                To protect your information, we’ll send a one-time secure access code.<br/><br/>
                                                Select a phone number:
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 16 }}>
                                                {phoneEntries.map(([label, phone], idx) => (
                                                    <div key={idx} style={{ marginBottom: 8 }}>
                                                        <button
                                                            type="button"
                                                            style={{
                                                                background: '#e5e7eb',
                                                                border: 'none',
                                                                borderRadius: '6px',
                                                                padding: '8px 16px',
                                                                fontSize: '1.1rem',
                                                                color: '#111827',
                                                                textDecoration: 'none',
                                                                cursor: 'pointer',
                                                                marginBottom: '4px',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center',
                                                                minWidth: 200,
                                                                width: '100%',
                                                                maxWidth: 320,
                                                            }}
                                                            onClick={() => {
                                                                setSelectedPhoneIndex(selectedPhoneIndex === idx ? null : idx);
                                                                setSelectedMfaMethod('');
                                                            }}
                                                        >
                                                            {maskPhoneNumber(phone.replace(/\D/g, ''))}
                                                            {/* Optionally show label: {label} */}
                                                            {selectedPhoneIndex === idx && (
                                                            <div style={{ marginTop: 8, marginLeft: 0, display: 'flex', gap: '12px' }}>
                                                                <button
                                                                    type="button"
                                                                    onClick={(e) => {
                                                                        handleSendSACCode('sms');
                                                                        setMfaMethod('sms');
                                                                        e.stopPropagation();
                                                                    }}
                                                                    style={{
                                                                        padding: '8px 16px',
                                                                        backgroundColor: selectedMfaMethod === 'sms' ? '#0078D4' : '#f3f2f1',
                                                                        color: selectedMfaMethod === 'sms' ? '#ffffff' : '#000000',
                                                                        border: '1px solid #ccc',
                                                                        borderRadius: '4px',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                    >
                                                                    SMS Text
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={(e) => {
                                                                        handleSendSACCode('call');
                                                                        setMfaMethod('call');
                                                                        e.stopPropagation();
                                                                    }}
                                                                    style={{
                                                                        padding: '8px 16px',
                                                                        backgroundColor: selectedMfaMethod === 'call' ? '#0078D4' : '#f3f2f1',
                                                                        color: selectedMfaMethod === 'call' ? '#ffffff' : '#000000',
                                                                        border: '1px solid #ccc',
                                                                        borderRadius: '4px',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                    >
                                                                    Phone/Voice
                                                                </button>
                                                            </div>
                                                            )}
                                                        </button>
                                                    </div>

                                                ))}
                                            </div>
                                            <div style={{ textAlign: 'center', margin: '24px 40px 0 40px', color: '#b91c1c', fontWeight: 500, fontSize: '1rem' }}>
                                                Security Reminder:<br />
                                                Do not share this code with anyone. We will never ask you to provide your secure access code by phone, email, or text.
                                            </div>
                                            <div className='actions justify-center flex mt-6'>
                                                <button onClick={() => { setIsConfirmModalOpen(false); setModalStep('confirm'); }} className="bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400 transition duration-200" style={{ marginRight: 8 }}>
                                                    Cancel
                                                </button>
                                                
                                            </div>
                                        </>
                                    )}
                                    {/* Step 3: MFA Code Entry */}
                                    {modalStep === 'mfa-code' && (
                                        <>
                                            <div className='flex flex-col items-center mb-4'>
                                                <h2 className='text-2xl font-semibold'>Verify Your Identity</h2>
                                            </div>
                                            <div style={{ textAlign: 'center', margin: '0 40px 16px 40px' }}>
                                                Please enter the 6-digit code you received to continue.
                                            </div>
                                            <div className="flex flex-col items-center space-y-4">
                                                <input
                                                    type="text"
                                                    value={mfaCode}
                                                    onChange={e => {
                                                        // Only allow 6 digits
                                                        const val = e.target.value.replace(/\D/g, '').slice(0, 6);
                                                        setMfaCode(val);
                                                        setMfaError('');
                                                    }}
                                                    maxLength={6}
                                                    className="px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-32 text-lg text-center"
                                                    placeholder="6-digit code"
                                                />
                                                {mfaError && <div className="text-red-600">{mfaError}</div>}
                                            </div>
                                            <div style={{ textAlign: 'center', margin: '24px 40px 0 40px', color: '#b91c1c', fontWeight: 500, fontSize: '1rem' }}>
                                                Security Reminder:<br />
                                                Do not share this code with anyone. We will never ask you to provide your secure access code by phone, email, or text.
                                            </div>
                                            <div className='actions justify-center flex mt-6'>
                                                <button onClick={() => { setIsConfirmModalOpen(false); setModalStep('confirm'); setMfaCode(''); }} className="bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400 transition duration-200" style={{ marginRight: 8 }}>
                                                    Cancel
                                                </button>
                                                <button
                                                    type='button'
                                                    disabled={mfaCode.length !== 6}
                                                    onClick={handleVerifySACCode}
                                                    className={`px-6 py-2 rounded-md transition duration-200 ${mfaCode.length === 6 ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}`}
                                                >
                                                    Verify
                                                </button>
                                            </div>
                                            <div style={{ textAlign: 'center', marginTop: 12, marginBottom: 12 }}>
                                                Didn’t get the code? <span style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => {handleSendSACCode(mfaMethod)}}>Resend Code</span><br/>
                                                Need help? Contact us at <a href="tel:3342602600" style={{ color: 'blue', textDecoration: 'underline' }}>334.260.2600</a> or <a href="tel:18007766776" style={{ color: 'blue', textDecoration: 'underline' }}>1.800.776.6776</a>
                                            </div>
                                        </>
                                    )}
                                    <br/>
                                </div>
                            )}
                            </Popup>
                        )
                    }
                        </div>
                        
                    ) 
                    : message.type==='successSubmit' ? (
                        <div>
                            <p>Your contact information has been updated in our system!</p>
                            <p>Please navigate to <a href="https://digital.mymax.com/settings/security" style={{ color: 'blue' }} target="_blank" rel="noopener noreferrer">
                                    Security
                                </a> and <a href="https://digital.mymax.com/settings/alerts" style={{ color: 'blue' }} target="_blank" rel="noopener noreferrer">
                                    Alert
                                </a> Settings to ensure that your 2-step verification codes and online banking notifications are sent to the correct contact points. </p>
                             </div>
                    )
                    : (
                        <div><p>ERROR {message.text},{message.type}</p></div>
                    )
                }
            </div>
        ) 
        : (
        <form className="flex-grow flex flex-col items-center justify-center pt-24 space-y-8">
            <div className="flex flex-col items-center space-y-4" style={{marginRight: '5%', marginLeft: '5%'}}>
                {message.type === 'invalid' && (
                    <div>
        <p
            className="text-base font-bold bg-red-700 px-4 py-2 rounded"
            style={{
                backgroundColor: '#F2DEDE', // Tailwind red-700
                color: '#AF504E',              // White text for contrast
                fontWeight: 'bold',
                fontSize: '1.1rem',
                padding: '1rem',
                borderRadius: '0.5rem',
                textAlign: 'center'
            }}
        >
            We do not recognize the address entered below. Please review and try again.
        </p></div>
                )}
                <label htmlFor="street" className="text-gray-700 text-base">Street Address:</label>
                <input type="text" id="street" name="street" value={street} onChange={(e) => setStreet(e.target.value)} className="px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full max-w-[400px] text-lg"/>
                <p style={{
                fontSize: '0.7rem',marginRight: '47%',marginTop: '20%'}}>List full street address including apartment number, suite number, etc. </p>
                <br/>
                <label htmlFor="city" className="text-gray-700 text-base">City:</label>
                <input type="text" id="city" name="city" value={city} onChange={(e) => setCity(e.target.value)} className="px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full max-w-[400px] text-lg"/>
                <br/>
                <label htmlFor="state" className="text-gray-700 text-base">State:</label>
                <select id="state" name="state" value={state} onChange={(e) => setState(e.target.value)} className="px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full max-w-[400px] text-lg">
                    <option value="">Select a state</option> 
                    <option value="AL">Alabama</option>
                    <option value="AK">Alaska</option>
                    <option value="AZ">Arizona</option>
                    <option value="AR">Arkansas</option>
                    <option value="CA">California</option>
                    <option value="CO">Colorado</option>
                    <option value="CT">Connecticut</option>
                    <option value="DE">Delaware</option>
                    <option value="FL">Florida</option>
                    <option value="GA">Georgia</option>
                    <option value="HI">Hawaii</option>
                    <option value="ID">Idaho</option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                    <option value="KS">Kansas</option>
                    <option value="KY">Kentucky</option>
                    <option value="LA">Louisiana</option>
                    <option value="ME">Maine</option>
                    <option value="MD">Maryland</option>
                    <option value="MA">Massachusetts</option>
                    <option value="MI">Michigan</option>
                    <option value="MN">Minnesota</option>
                    <option value="MS">Mississippi</option>
                    <option value="MO">Missouri</option>
                    <option value="MT">Montana</option>
                    <option value="NE">Nebraska</option>
                    <option value="NV">Nevada</option>
                    <option value="NH">New Hampshire</option>
                    <option value="NJ">New Jersey</option>
                    <option value="NM">New Mexico</option>
                    <option value="NY">New York</option>
                    <option value="NC">North Carolina</option>
                    <option value="ND">North Dakota</option>
                    <option value="OH">Ohio</option>
                    <option value="OK">Oklahoma</option>
                    <option value="OR">Oregon</option>
                    <option value="PA">Pennsylvania</option>
                    <option value="RI">Rhode Island</option>
                    <option value="SC">South Carolina</option>
                    <option value="SD">South Dakota</option>
                    <option value="TN">Tennessee</option>
                    <option value="TX">Texas</option>
                    <option value="UT">Utah</option>
                    <option value="VT">Vermont</option>
                    <option value="VA">Virginia</option>
                    <option value="WA">Washington</option>
                    <option value="WV">West Virginia</option>
                    <option value="WI">Wisconsin</option>
                    <option value="WY">Wyoming</option>
                </select>
                <br/>
                <label htmlFor="zipcode" className="text-gray-700 text-base">Zipcode:</label>
                <input type="text" id="zipcode" name="zipcode" value={zipcode} onChange={(e) => setZipcode(e.target.value)} className="px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full max-w-[400px] text-lg"/>
                <br/>
                <label htmlFor="homePhone" className="text-gray-700 text-base">Home Phone:</label>
                <input type="text" id="homePhone" name="homePhone" value={homePhone} 
                    onChange={(e) => {
                        const formatted = formatPhoneNumber(e.target.value);
                        setHomePhone(formatted);
                    }}
                    maxLength={12}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full max-w-[400px] text-lg"/>
                <br/>
                <label htmlFor="workPhone" className="text-gray-700 text-base">Work Phone:</label>
                <input type="text" id="workPhone" name="workPhone" value={workPhone} 
                    onChange={(e) => {
                        const formatted = formatPhoneNumber(e.target.value);
                        setWorkPhone(formatted);
                    }}
                    maxLength={12}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full max-w-[400px] text-lg"/>
                <br/>
                <label htmlFor="mobilePhone" className="text-gray-700 text-base">Mobile Phone:</label>
                <input type="text" id="mobilePhone" name="mobilePhone" value={mobilePhone} 
                    onChange={(e) => {
                        const formatted = formatPhoneNumber(e.target.value);
                        setMobilePhone(formatted);
                    }}
                    maxLength={12}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full max-w-[400px] text-lg"/>
                <br/>
                <label htmlFor="email" className="text-gray-700 text-base">Email Address:</label>
                <input type="email" id="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} className="px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full max-w-[400px] text-lg"/>
                <br/>
                <label htmlFor="contactMethod" className="text-gray-700 text-base">Preferred Contact Method:</label>
                <select id="contactMethod" name="contactMethod" value={contactMethod}  onChange={(e) => setContactMethod(e.target.value)} className="px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full max-w-[400px] text-lg">
                    <option value="CALL HOME">Call Home</option> 
                    <option value="CALL WORK">Call Work</option> 
                    <option value="CALL MOBILE">Call Mobile</option> 
                    <option value="TEXT MOBILE">Text Mobile</option> 
                    <option value="SEND EMAIL">Send Email</option> 
                </select>
                <br/>
                <label htmlFor="promotional" className="text-gray-700 text-base flex items-center">
                    <input type="checkbox" checked={checkBox} onChange={(e) => setCheckBox(e.target.checked)} id="promotional" name="promotional" className="mr-6" style={{marginRight: '10px'}}/>
                    I agree to receive promotional messages by phone or SMS from MAX (data rates may apply).
                </label>
                <br/>
                <div>
                    <button type="button" className="mt-4 bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400 transition duration-200" onClick={() => { window.location.href = 'https://digital.mymax.com/'; }}>Back</button>
                    <button type="submit" 
                        onClick={() => {handleConfirmAddressChange();}}
                        className="mt-4 bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition duration-200">Submit</button>
                </div>
            </div>
        </form>
    )}
    </div>
    </div>
    );
}

export default AddressChange;
